import { createRouter } from '@swan-io/chicane';

import { consoleRoutes } from '@dotfile/shared/domain';

// @TODO - E-2224 - Move console router from lib back to app
export const Router = createRouter(consoleRoutes);
